<template>
  <div class="container">
    <Header></Header>
    <Banners :banner="banner"></Banners>
    <CompanyInfo></CompanyInfo>
    <JoinUs></JoinUs>
    <JobPosition></JobPosition>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/components/Header"
  import Footer from "@/components/Footer"
  import Banners from "@/components/Banners"
  import CompanyInfo from "@/components/Contact_Us/CompanyInfo"
  import JoinUs from "@/components/Contact_Us/JoinUs"
  import JobPosition from "@/components/Contact_Us/JobPosition"

  export default {
    name: 'Contact_Us',
    data() {
      return {
        banner: require("@/assets/imgs/bg-banner-contackus.png")
      }
    },
    components: {
      Header, Banners,Footer,CompanyInfo,JoinUs,JobPosition
    },
    created() {
      this.$store.commit('changeNavs', 'Contact_Us')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    min-width: 1350px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Contact_Us.vue